
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift",
      function () {
        return require("private-next-pages/gift.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gift"])
      });
    }
  